import styled from 'styled-components';
import * as COLORS from 'Constants/colors';

export default Base => styled(Base)`
  transition: transform 220ms ease, filter 220ms ease;
  position: relative;
  cursor: pointer;

  > a {
    color: inherit;
    display: block;
    text-decoration: none;
  }

  &:hover {
    transform: translateY(-4px);

    .package-availability-card-container {
      box-shadow: 0 10px 28px rgba(23, 31, 75, 0.16);
    }
  }

  .package-availability-card-container {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    background-color: ${COLORS.white};
    position: relative;
    overflow: hidden;
    transition: box-shadow 220ms ease;
  }

  .content-holder {
    display: flex;
    flex-direction: column;
    padding: 16px;
  }

  .title-holder {
    p {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 1.25;
      margin: 0;
      overflow: hidden;
    }
  }

  .meta-holder {
    display: flex;
    flex-direction: column;
    margin-top: 8px;

    p {
      line-height: 1.35;
      margin: 0;
    }
  }

  .include-holder {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }

  .include-chip {
    border: 1px solid ${COLORS.lightGrey};
    border-radius: 999px;
    color: ${COLORS.darkGrey};
    display: inline-flex;
    font-family: Montserrat, serif;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    max-width: 100%;
    padding: 6px 8px;
    white-space: nowrap;
  }

  .include-chip.more {
    border-color: ${COLORS.important};
    color: ${COLORS.important};
    cursor: pointer;

    &:focus {
      box-shadow: 0 0 0 2px rgba(255, 103, 0, 0.18);
      outline: none;
    }
  }

  .prices-holder {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-top: 12px;

    > div:first-child {
      justify-content: flex-start;
    }

    .price-label {
      color: ${COLORS.darkGrey};
      line-height: 1.2;
      margin: 0 0 2px;
    }

    > div {
      align-items: center;
      margin-bottom: 2px;
    }

    > div > div {
      align-items: baseline;
      flex-direction: row;
      gap: 4px;
      justify-content: flex-start;
      margin-right: 4px;
    }

    > div > div span:first-child {
      display: none;
    }

    h2,
    h4 {
      color: ${COLORS.newBackground};
      font-size: 26px;
      font-weight: 700;
      line-height: 1.05;
    }

    span {
      color: ${COLORS.newBackground};
    }

    > span,
    > p {
      line-height: 1.35;
      margin: 0;
    }

    .travel-date {
      color: ${COLORS.darkGrey};
      margin-top: 4px;
    }
  }

  .package-availability-card-image {
    position: relative;
    background-color: ${COLORS.greyBkg};
    height: 0;
    padding-top: 62%;

    .img {
      inset: 0;
      overflow: hidden;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-placeholder {
      align-items: center;
      background: linear-gradient(135deg, ${COLORS.newBackground}, #704591);
      display: flex;
      height: 100%;
      inset: 0;
      justify-content: center;
      padding: 24px;
      position: absolute;
      text-align: center;
      width: 100%;
    }

    &::after {
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 45%,
        rgba(0, 0, 0, 0.35) 100%
      );
      content: '';
      inset: 0;
      pointer-events: none;
      position: absolute;
    }

    .icons-holder {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.42);
      backdrop-filter: blur(3px);
      bottom: 10px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 10px;
      min-height: 32px;
      left: 10px;
      padding: 0 12px;
      z-index: 1;

      span {
        margin-right: 0;
      }
    }

    .tag-holder {
      position: absolute;
      background-color: ${COLORS.orange};
      min-height: 28px;
      top: 12px;
      left: 12px;
      display: flex;
      align-items: center;
      max-width: calc(100% - 24px);
      padding: 0 12px;
      border-radius: 999px;
      z-index: 1;

      span {
        font-size: 11px;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .cta-holder {
    align-items: center;
    background-color: ${COLORS.newBackground};
    border-radius: 8px;
    color: ${COLORS.white};
    display: flex;
    font-family: Montserrat, serif;
    font-size: 14px;
    font-weight: 700;
    justify-content: center;
    margin-top: 12px;
    min-height: 44px;
    transition: filter 220ms ease;

    &:hover {
      filter: brightness(1.08);
    }
  }
`;
